import clsx from "clsx";
import { default as config } from "common/config/config";
import useTranslate from "ui/locale/hooks/useTranslate";
import { FormGridBannerRoot } from "./FormGridBanner.styles";

export interface FormGridBannerProps {
    className?: string;
    style?: React.CSSProperties;
    isEditing?: boolean;
}

function FormGridBanner({ className, isEditing, ...rest }: FormGridBannerProps) {
    const translate = useTranslate();

    return (
        <FormGridBannerRoot
            input="image"
            className={clsx("form-grid-banner", className)}
            name="banner"
            label={translate("banner")}
            fullWidth
            alt="partner-banner"
            showControllers={false}
            editable={isEditing}
            hint={translate("recommendedSize", {
                height: config.validators.partner.bannerHeight,
                width: config.validators.partner.bannerWidth,
            })}
            required={false}
            size="lg"
            {...rest}
        />
    );
}

export default FormGridBanner;
